/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum PersonDataChangeRequestsAliases {
  CHANGE_REQUEST_LAYOUT = 'change-request-layout',
  DATA_TABLE_COLUMN_ARROW_ICON = 'data-table-column-arrow-icon',
  DECK_DATA_CHANGE_REQUEST = 'deck-data-change-request',
  HPMS_ALTERACAO_CADASTRO_CARD_0 = 'hpms-alteracao-cadastro-card-0',
  MEDIA_QUERY_0 = 'media-query-0',
  MEDIA_QUERY_PERSON_DATA_CHANGE_REQUEST = 'media-query-person-data-change-request',
  PANEL_0 = 'panel-0',
  PERSON_DATA_CHANGE_REQUESTS_DATA_TABLE_COLUMN_STATUS = 'personDataChangeRequestsDataTableColumnStatus',
  PERSON_DATA_CHANGE_REQUESTS_DATATABLE = 'personDataChangeRequestsDatatable',
  PERSON_DATA_CHANGE_REQUESTS_DATATABLE_COLUMN_ATTRIBUTE = 'personDataChangeRequestsDatatableColumnAttribute',
  PERSON_DATA_CHANGE_REQUESTS_DATATABLE_COLUMN_OLD_VALUE = 'personDataChangeRequestsDatatableColumnOldValue',
  PERSON_DATA_CHANGE_REQUESTS_DATATABLE_COLUMN_REQUEST_DATE = 'personDataChangeRequestsDatatableColumnRequestDate',
  PERSON_DATA_CHANGE_REQUESTS_DATATABLE_COLUMN_REQUESTED_VALUE = 'personDataChangeRequestsDatatableColumnRequestedValue',
  PERSON_DATA_CHANGE_REQUESTS_FETCH = 'person-data-change-requests-fetch',
}
export { PersonDataChangeRequestsAliases };
